import { apiGet } from "../lib/api-client";
import type { StoreItemKind, StoreItemRarity } from "./store";

// API client for the WS-11 time-bound events read surface (routes/events.ts,
// mounted at /events). Mirrors packages/db/src/events.ts's EventWithProgress
// exactly — do not invent fields.

export type EventRuleType = "peak_count" | "trail_section_count" | "landmark_count" | "total_distance";
export type EventStatus = "active" | "upcoming" | "ended";

export interface EventRewardItem {
  id: string;
  slug: string;
  name: string;
  kind: StoreItemKind;
  rarity: StoreItemRarity;
  metadata: unknown;
}

export interface EventWithProgress {
  id: string;
  slug: string;
  name: string;
  description: string;
  startsAt: string;
  endsAt: string;
  ruleType: EventRuleType;
  ruleParams: Record<string, unknown>;
  rewardWaypoints: number;
  rewardItems: EventRewardItem[];
  status: EventStatus;
  completed: boolean;
  completedAt: string | null;
  progress: { current: number; target: number };
}

export function fetchEvents(): Promise<{ events: EventWithProgress[] }> {
  return apiGet("/events");
}
